// ViewEditOrganization
import React from 'react';
import { Popconfirm, Menu, Icon, Dropdown, Upload, notification } from 'antd';
import { reduxForm, Field, FieldArray, isDirty, FormSection } from 'redux-form';
import { validate } from '../../../utils/Validations/organizationValidaton';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { customInput } from '../../common/custom-input';
import { CustomSelect } from '../../common/customSelect';
import * as actions from '../../../actions/organizationAction';
import * as subscriptionAction from '../../../actions/subscriptionAction';
import * as rolesActions from '../../../actions/roleManagementActions';
import * as orgUserActions from '../../../actions/organizationUserAction';
import { Strings } from '../../../dataProvider/localize';
import AddEditBillingDetails from './AddEditBillingDetails';
import EditBillingAddress from './EditBillingAddress';
import { customTextarea } from '../../common/customTextarea';
import $ from 'jquery';
import UpdateSingleUser from './UpdateSingleUser';
import {
  abbrivationStr,
  currencyFormat,
  DeepTrim , handleFocus
} from '../../../utils/common';
import { countryCodes } from '../../../dataProvider/countryCodes'
import moment from 'moment';
import EditSubscriptionLevel from './EditSubscriptionLevel';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { VALIDATE_STATUS } from '../../../dataProvider/constant'
import AddServiceAgentIndustry from './AddServiceAgentIndustry';
import RenderServicesArrayView from './RenderServicesArrayView';
import EditSingleService from './EditSingleService';
import * as subcategoryAction from '../../../actions/subCategoryManagementActions';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

class ViewEditOrganization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayEdit: 'none',
      billingFlag: 'none',
      addressInfoFlag: 'none',
      showSubscriptionLevel: 'none',
      fileList: [],
      active: true,
      inlineUsers: [],
      logoImageURL: null,
      cardExpnadBtn: true,
      industryFlag: 'none',
    }
    this.props.subscriptionAction.getSubscription();
    this.props.rolesActions.getRoles();
  }

  //showEdit // showAdd
  // static getDerivedStateFromProps(props, state) {
  //   //state.logoImageURL = null
  //   // imageURL = null
  //   // fileObj = null
  // }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.initialValues && nextProps.initialValues.name && prevState && prevState.name && nextProps.initialValues.name !== prevState.name) {
      return {
        name: nextProps.initialValues.name,
        logoImageURL: null,
        fileList: []
      };
    }
    return null;
  }

  onSubmit = async formData => {
    formData = await DeepTrim(formData);

    delete formData.billing_email_address;
    delete formData.logo
    let finalFormData = new FormData();
    Object.keys(formData).forEach(key => {
      finalFormData.append(key, formData[key]);
    })
    if (this.state.fileList.length > 0) {
      finalFormData.append('logo', this.state.fileList[0]);
    }
    this.props.action.updateOrganization(finalFormData).then((message) => {
      this.handleCancel();
      notification.success({
        message: Strings.success_title,
        description: message,
        onClick: () => { },
        className: 'ant-success'
      });
    }).catch((error) => {
      if (error.status === VALIDATE_STATUS) {
        notification.warning({
          message: Strings.validate_title,
          description: error && error.data && typeof error.data.message === 'string'
            ? error.data.message : Strings.generic_validate,
          onClick: () => { },
          className: 'ant-warning'
        });
      } else {
        notification.error({
          message: Strings.error_title,
          description: error && error.data && error.data.message && typeof error.data.message === 'string'
            ? error.data.message : Strings.generic_error,
          onClick: () => { },
          className: 'ant-error'
        });
      }
    });

  }


  handleEditClick = () => {
    this.setState({
      displayEdit: 'block',
      billingFlag: 'none',
      addressInfoFlag: 'none',
      showSubscriptionLevel: 'none',
      industryFlag: 'none',
    });
    if (!this.state.cardExpnadBtn) {
      this.handleExpand()
    }
  }

  handleCancel = () => {
    this.setState({
      displayEdit: 'none',
      billingFlag: 'none',
      addressInfoFlag: 'none',
      showSubscriptionLevel: 'none',
      industryFlag: 'none',
    });
  }

  handleUserManageClick = () => {
    let organization = this.props.organizations.find(organ => organ.id === this.props.location.state)
    this.props.history.push({ pathname: '/dashboard/userManagement', state: { org_id: organization.id, org_name: organization.name } })
  }

  addBillingDetailsHandler = () => {
    this.setState({
      billingFlag: 'showAdd',
      displayEdit: 'none',
      addressInfoFlag: 'none',
      showSubscriptionLevel: 'none',
      industryFlag: 'none',
    });
    if (!this.state.cardExpnadBtn) {
      this.handleExpand()
    }
  }

  EditBillingDetailsHandler = () => {
    this.setState({
      billingFlag: 'showEdit',
      displayEdit: 'none',
      addressInfoFlag: 'none',
      showSubscriptionLevel: 'none',
      industryFlag: 'none',
    });
    if (!this.state.cardExpnadBtn) {
      this.handleExpand()
    }
  }

  EditBillingAddressHandler = () => {
    this.setState({
      billingFlag: 'none',
      displayEdit: 'none',
      addressInfoFlag: 'block',
      showSubscriptionLevel: 'none',
      industryFlag: 'none',
    });
    if (!this.state.cardExpnadBtn) {
      this.handleExpand()
    }
  }

  EditSubscriptionLevelHandler = () => {
    this.setState({
      billingFlag: 'none',
      displayEdit: 'none',
      addressInfoFlag: 'none',
      showSubscriptionLevel: 'block',
      industryFlag: 'none',
    });
    if (!this.state.cardExpnadBtn) {
      this.handleExpand()
    }
  }

  userMenu = (<Menu>
    <Menu.Item onClick={this.handleUserManageClick}>{Strings.menu_user_mgmt}</Menu.Item>
  </Menu>);

  editBillingMenu = (<Menu>
    <Menu.Item onClick={this.EditBillingAddressHandler}>{Strings.menu_edit_bill}</Menu.Item>
    <Menu.Item onClick={this.EditBillingDetailsHandler}>{Strings.menu_update_payment}</Menu.Item>
  </Menu>);

  addBillingMenu = (<Menu>
    <Menu.Item onClick={this.EditBillingAddressHandler}>{Strings.menu_update_payment}</Menu.Item>
  </Menu>);

  editSubscriptionLevelMenu = (<Menu>
    <Menu.Item onClick={this.EditSubscriptionLevelHandler}>{Strings.menu_update_subscription_level}</Menu.Item>
  </Menu>);

  editMenu = (
    <Menu>
      <Menu.Item onClick={this.handleEditClick}>{Strings.menu_edit_org}</Menu.Item>
    </Menu>
  )

  removeFile = () => this.setState({ fileList: [] });
  renderMembers = ({ fields, meta: { error, submitFailed } }) => (
    <>
      {fields.length > 0 ? <div className="sf-c-table org-user-table ve-a-user-t ad-nusr-txt">
        {fields.map((member, index) => (
          <div className="tr" key={index}>
            <span className="td">
              <fieldset className="sf-form">
                <Field
                  name={`${member}.name`}
                  placeholder={Strings.name_user_org}
                  type="text"
                  component={customInput}
                />
              </fieldset>
            </span>
            <span className="td">
              <fieldset className="sf-form">
                <Field
                  name={`${member}.email_address`}
                  placeholder={Strings.email_address_org}
                  type="text"
                  component={customInput}
                />
              </fieldset>
            </span>
            <span className="td">
              <div className="co-code-mobile-no">
                <fieldset className="sf-form co-code-txt">
                  <Field
                    name={`${member}.country_code`}
                    placeholder={Strings.phone_number_user_org}
                    type="text"
                    showSearch={1}
                    defaultValue="+61"
                    options={countryCodes.map(country => ({
                      title: country.dial_code,
                      value: country.dial_code
                    }))}
                    component={CustomSelect}
                  />
                </fieldset>
                <fieldset className="sf-form mobile-ntxt">
                  <Field
                    name={`${member}.phone_number`}
                    placeholder={Strings.phone_number_user_org}
                    type="text"
                    maxLength="10"
                    component={customInput}
                  />
                </fieldset>
              </div>
            </span>
            <span className="td">
              <fieldset className="sf-form">
                <Field
                  name={`${member}.role_id`}
                  placeholder={Strings.role_id_user_org}
                  type="text"
                  options={this.props.roles ? this.props.roles.map(role => ({ title: role.name, value: role.id })) : []}
                  component={CustomSelect}
                />
              </fieldset>
            </span>
            <span className="td"><button className='delete-bnt' type='button' onClick={() => fields.remove(index)}><i className="fa fa-trash-o"></i></button></span>
          </div>
        ))}
      </div> : null}
      <div className="btn-hs-icon sm-bnt bnt-error">
        <button className="bnt bnt-normal" type="button" onClick={() => fields.push({ country_code: "+61", role_id: [] })}>{Strings.add_user_btn}</button>
        {submitFailed && error && <span className="error-input">{error}</span>}
      </div>
    </>
  )

  handleOrgUserSubmit = (formData) => {
    console.log("orguser", formData);

    if (formData.org_users) {
      let finalForm = { org_users: [] };
      formData.org_users.forEach(user => {
        finalForm.org_users.push({ ...user, organisation_id: this.props.initialValues.id })
      })
      this.props.orgUserActions.updateUsersFromView(finalForm, this.props.initialValues.id).then((message) => {
        this.props.change('org_users', []);
        notification.success({
          message: Strings.success_title,
          description: message,
          onClick: () => { },
          className: 'ant-success'
        });
      }).catch((error) => {
        if (error.status === VALIDATE_STATUS) {
          notification.warning({
            message: Strings.validate_title,
            description: error && error.data && typeof error.data.message === 'string'
              ? error.data.message : Strings.generic_validate,
            onClick: () => { },
            className: 'ant-warning'
          });
        } else {
          notification.error({
            message: Strings.error_title,
            description: error && error.data && error.data.message && typeof error.data.message === 'string'
              ? error.data.message : Strings.generic_error,
            onClick: () => { },
            className: 'ant-error'
          });
        }
      });
    }
  }

  handdleDeleteUserClick = (user) => {
    if (user.role.org_default_role === 1 && this.props.users && this.props.users.filter(
      user => user.role.org_default_role === 1
    ).length < 2) {
      notification.error({
        message: Strings.error_title,
        description: Strings.user_list_delete_alert,
        onClick: () => { },
        className: 'ant-error'
      });
      return
    }

    this.props.orgUserActions.deleteOrganizationUser({
      organisation_id: user.organisation_id,
      user_name: user.user_name
    }, this.props.initialValues.id).then(message => {
      notification.success({
        message: Strings.success_title,
        description: message,
        onClick: () => { },
        className: 'ant-success'
      });
    }).catch((message) => {
      notification.error({
        message: Strings.error_title,
        description: message ? message : Strings.generic_error,
        onClick: () => { },
        className: 'ant-error'
      });
    });
  }

  handleUserEditClick = (user) => {
    let { inlineUsers } = this.state
    inlineUsers.push(user.id);
    this.setState({ inlineUsers })
  }

  removeInlineUser = (user) => {
    let { inlineUsers } = this.state
    let index = inlineUsers.findIndex(id => id === user.id)
    if (index !== -1) {
      inlineUsers.splice(index, 1);
    }
    this.setState({ inlineUsers })
  }

  // expand center card----------
  handleExpand = () => {
    this.setState({ cardExpnadBtn: !this.state.cardExpnadBtn })
    $(".main-container").toggleClass("po-relative");
    $(".sf-card-wrap").toggleClass("fullscreen");
  }

  onIndustrySubmit = formData => {

    let finalFormUpdate = {
      service_agent_id: formData.id,
      org_industries: [...formData.org_industries]
    }
    if (formData.org_services) {
      Object.keys(formData.org_services).forEach(key => {
        let industryObj = formData.org_services[key];
        industryObj.industry_id = parseInt(key.split('$')[1]);
        finalFormUpdate.org_industries.push(industryObj);
      })
    }

    if (finalFormUpdate.org_industries.length > 0 && Object.keys(finalFormUpdate.org_industries[finalFormUpdate.org_industries.length - 1]).length === 0) {
      finalFormUpdate.org_industries.pop()
    }
    if (finalFormUpdate.org_industries.length > 0) {
      this.props.action.updateServiceAgentService(finalFormUpdate)
        .then((flag) => {
          this.props.reset();
          this.props.industryManagementAction.getSubCategories();
        })
        .catch((error) => {
          if (error.status === VALIDATE_STATUS) {
            notification.warning({
              message: Strings.validate_title,
              description: error && error.data && typeof error.data.message === 'string'
                ? error.data.message : Strings.generic_validate,
              onClick: () => { },
              className: 'ant-warning'
            });
          } else {
            notification.error({
              message: Strings.error_title,
              description: error && error.data && error.data.message && typeof error.data.message === 'string'
                ? error.data.message : Strings.generic_error,
              onClick: () => { },
              className: 'ant-error'
            });
          }
        });
    }

  }

  handleServiceDelete = service_id => {
    this.props.action.deleteSAService({
      service_agent_id: this.props.initialValues.id,
      service_id: service_id
    })
      .then((flag) => {
        this.props.reset();
      })
      .catch((message) => {
        notification.error({
          message: "Error!",
          description: message ? message : "Something went wrong please try again later",
          onClick: () => { },
          className: 'ant-error'
        });
      });
  }

  handleIndustryEditClick = (service, industry_id) => {
    this.setState({
      displayEdit: 'none',
      industryFlag: 'block',
      addressInfoFlag: 'none',
      changeSubscriptionFlag: 'none',
      selectedService: service,
      selectedIndustryId: industry_id
    });
    if (!this.state.cardExpnadBtn) {
      this.handleExpand()
    }
  }

  handleIndustryDelete = industry_id => {
    this.props.action.deleteSAIndustry({
      service_agent_id: this.props.initialValues.id,
      industry_id: industry_id
    }).then((flag) => {
      this.props.reset();
    })
      .catch((message) => {
        notification.error({
          message: "Error!",
          description: message ? message : "Something went wrong please try again later",
          onClick: () => { },
          className: 'ant-error'
        });
      });
  }
  displayIndustries = (organization) => (
    <FormSection name="org_services">{
      organization.org_industries
        .map((industry) => <div className="sf-card-inner">
          <div className="view-text-value edit-si-box"><label>{Strings.service_inductry_txt}</label>
            <span>{this.props.industries && this.props.industries.find(ind => ind.id === industry.industry_id) ?
              this.props.industries.find(ind => ind.id === industry.industry_id).industry_name : ""}</span>
            <div className="doc-action-bnt">
              <button className="normal-bnt"><i className="material-icons"
                onClick={() => this.handleIndustryEditClick(industry, industry.industry_id)}>edit</i></button>
              <button className="normal-bnt"><i className="fa fa-trash-o" onClick={() => this.handleIndustryDelete(industry.industry_id)}></i></button>
            </div>
          </div>
          {industry.services && industry.services.forEach(service => {
            if (service.service_id) {
              return <div className="add-sfs-agent">
                <div className="sf-card-inn-bg pl-0 pt-0">
                  <div className="view-text-value sa-cat-heading">
                    <button className="dragde-bnt normal-bnt">
                      <i className="material-icons">more_horiz</i>
                      <i className="material-icons">more_horiz</i>
                    </button>
                    <label>{this.props.services && this.props.services.find(ser => ser.id === service.service_id) ?
                      this.props.services.find(ser => ser.id === service.service_id).service_name :
                      null}</label>
                    <div className="doc-action-bnt">
                      <button className="normal-bnt" onClick={() => this.handleServiceDelete(service.service_id)}><i className="fa fa-trash-o"></i></button>
                    </div>
                  </div>
                  <div className="sa-cat-pleft">
                    {service.categories && service.categories.forEach(category => {
                      if (category.category_id) {
                        return <div className="sa-sub-cat">
                          <div className="view-text-value cat-view-value">
                            <label>{Strings.category_txt}</label>
                            <span>{this.props.categories && this.props.categories.find(cat => cat.id === category.category_id) ?
                              this.props.categories.find(cat => cat.id === category.category_id).category_name
                              : null}</span></div>
                          <div className="view-text-value">
                            <label>{Strings.sub_category_txt}</label>
                            <span className="sub-cat-value">
                              {category.subcategory && category.subcategory.map((subCategory, index) =>
                                <span>{index !== 0 ? <i>,</i> : null}
                                  {this.props.subCategories && this.props.subCategories.find((sub) => sub.id === subCategory.sub_category_id) ?
                                    this.props.subCategories.find(sub => sub.id === subCategory.sub_category_id).sub_category_name
                                    : null}</span>
                              )}</span></div>
                        </div>
                      }
                    })}</div>
                </div>
              </div>
            }
          })}
          <FormSection name={`$${industry.industry_id}`}>
            <FieldArray name={`services`} formValues={this.props.formValues && this.props.formValues.org_services &&
              this.props.formValues.org_services[`$${industry.industry_id}`]}
              industry_id={industry.industry_id} component={RenderServicesArrayView} change={this.props.change} />
          </FormSection>
        </div>)}
    </FormSection>
  )

  render() {
    const { handleSubmit, users, billingDetails } = this.props;
    let organization = this.props.organizations.find(organ => organ.id === this.props.location.state)
    const uploadPicProps = {
      beforeUpload: file => {
        this.setState({
          fileList: [file],
        });
        return false;
      },
      multiple: false,
      onChange: async (info) => {
        this.props.change(`isDirty`, false)
        await getBase64(info.file, imageUrl =>
          // imageURL = imageUrl,
          this.setState({
            logoImageURL: imageUrl,
            fileList: [info.file]
          })
        )
      },
      accept: ".jpeg,.jpg,.png",
      fileList: this.state.fileList,
      onRemove: this.removeFile
    };
    /*let userFlag = false;

    const deleteFunc = (user) => {
      if (!userFlag) {
        userFlag = true; return null
      }
      return <Popconfirm
        title={Strings.user_list_confirm_delete_alert}
        onConfirm={() => this.handdleDeleteUserClick(user)}
        placement="topRight"
        okText="Yes"
        cancelText="No"
        className="delete-bnt"
        getPopupContainer={() => document.getElementById('confirmPopPo')}

      >
        <button className='delete-bnt' userid={user.id}>
          <i className="fa fa-trash-o"></i>
        </button>
      </Popconfirm>
    }*/
    return (
      <div className={this.props.togleSearch ? "col-sm-12 col-md-9 col-lg-9" : "col-sm-12 col-md-9 col-lg-9 col-md-srch"}>
        <div className="row">
          <div className="col-md-12 col-lg-8">
            <div className="sf-card-wrap">
              {/* zoom button  */}
              <div className="card-expands">
                <button type="button" onClick={this.handleExpand} className="exapnd-bnt normal-bnt">
                  <Icon type={this.state.cardExpnadBtn ? "fullscreen" : "fullscreen-exit"} /></button>
              </div>
              <div className="sf-card sf-mcard">
                <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                  <h2 className="sf-pg-heading">{Strings.org_detail_card}</h2>
                  <div className="info-btn">
                    {/* Drop down for card */}
                    <Dropdown className="more-info" overlay={this.editMenu}>
                      <i className="material-icons">more_vert</i>
                    </Dropdown>
                    {/*Drop down*/}
                  </div>
                </div>
                {/**Organization Details */}
                <div className="sf-card-body mt-2">
                  <div className="row">

                    <div className="col org-logo-col">
                      <div className="view-logo">
                        {
                          organization
                            ? organization.logo
                              ? <img alt="" src={organization.logo} />
                              : <b>{abbrivationStr(organization.name)}</b>
                            : null
                        }
                      </div>
                    </div>

                    <div className="col">
                    <div className="data-v-row">
                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.org_name}</label>
                            <span>{organization ? organization.name : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.org_pri_person}</label>
                            <span>{organization ? organization.primary_person : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.org_phone}</label>
                            <span>{organization ? `${organization.phone_number}` : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.org_email}</label>
                            <span>{organization ? organization.email_address : ''}</span>
                          </div>
                        </div>
                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.website_txt}</label>
                            <span>{organization ? organization.website : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value pr-3">
                            <label>{Strings.org_address}</label>
                            <span>{organization ? organization.address : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.org_abn}</label>
                            <span>{organization ? organization.abn_acn : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value pr-3">
                            <label>{Strings.notification_email_txt}</label>
                            <span>{organization ? organization.notification_email : ''}</span>
                          </div>
                        </div>

                        <div className="data-v-col">
                          <div className="view-text-value">
                            <label>{Strings.short_code_txt}</label>
                            <span>{organization ? organization.org_code : ''}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Service Industries */}

              <div className={"sf-card sf-mcard v-sr-agent"}>
                <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                  <h2 className="sf-pg-heading">{Strings.service_inductries_txt}</h2>
                  {/* {this.permissions.sf_update_service_industry !== -1 ?
                    <div className="info-btn">
                    </div> : null} */}
                  <div className="info-btn disable-dot-menu">
                    <Dropdown className="more-info" disabled>
                      <i className="material-icons">more_vert</i>
                    </Dropdown>
                  </div>
                </div>

                <div className="sf-card-body">
                  <form onSubmit={handleSubmit(this.onIndustrySubmit)}>
                    {organization && organization.org_industries ?

                      this.displayIndustries(organization)
                      : null}
                    {/* <div className="btn-hs-icon sm-bnt">
                                    <button className="bnt bnt-normal" type="button">{Strings.add_industry_btn}</button>
                                </div> */}
                    <FieldArray
                      name="org_industries" component={AddServiceAgentIndustry} change={this.props.change} initValueFromEdit={true} />
                    {/* <div className="s-n-bnt btn-hs-icon sm-bnt ml-4">
                      <button type="submit" className="bnt bnt-active">
                        {Strings.update_btn}</button>
                    </div> */}
                  </form>
                </div>
              </div>

              {/* Billing Details section */}
              <div className="sf-card mt-4">
                <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                  <h2 className="sf-pg-heading">{Strings.bill_card}</h2>
                  <div className="info-btn">
                    <Dropdown className="more-info"
                      overlay={billingDetails.card_details === null ? this.addBillingMenu : this.editBillingMenu}>
                      <i className="material-icons">more_vert</i>
                    </Dropdown>
                  </div>
                </div>

                <div className="sf-card-body mt-2">

                  <div className="data-v-row">
                    <div className="data-v-col">
                      <div className="view-text-value">
                        <label>Address</label>
                        <span>{billingDetails.billing_address}</span>
                      </div>
                    </div>

                    <div className="data-v-col">
                      <div className="view-text-value">
                        <label>Email</label>
                        <span>{billingDetails.billing_email_address}</span>
                      </div>
                    </div>

                    <div className="data-v-col">
                      <div className="view-text-value">
                        <label>Next Payment Due</label>
                        <span>{moment(billingDetails.payment_due_date).format('DD MMM YYYY')}</span>
                      </div>
                    </div>
                  </div>

                  {billingDetails.card_details ?
                    <div className="data-v-row">
                      <div className="data-v-col">
                        <div className="view-text-value">
                          <label>Payment Method</label>
                          <span>{billingDetails.card_details.Number}</span>
                        </div>
                      </div>
                      <div className="data-v-col">
                        <div className="view-text-value">
                          <label>Card Expiry</label>
                          <span>{
                            (billingDetails
                              && billingDetails.card_details
                              && billingDetails.card_details.ExpiryMonth
                              && billingDetails.card_details.ExpiryYear)
                              ? billingDetails.card_details.ExpiryMonth + '/' + billingDetails.card_details.ExpiryYear
                              : null
                          }</span>
                        </div>
                      </div>
                    </div> : <button className="bnt bnt-active" onClick={this.addBillingDetailsHandler}><i className="material-icons">credit_card</i> {Strings.add_pay_meth_title}</button>}

                </div>
              </div>

              {/**User List */}
              <div className="sf-card sf-mcard my-4">
                <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                  <h2 className="sf-pg-heading">{Strings.org_user_card}</h2>
                  <div className="info-btn">
                    <Dropdown className="more-info" overlay={this.userMenu}>
                      <i className="material-icons">more_vert</i>
                    </Dropdown>
                  </div>
                </div>

                <div className="sf-card-body">
                  <PerfectScrollbar className="sf-ps-scroll">
                    <div className="sf-ps-scroll-content">
                      <div className="sf-c-table org-user-table">
                        <div className="tr">
                          <span className="th">{Strings.user_table_name}</span>
                          <span className="th">{Strings.user_table_email}</span>
                          <span className="th">{Strings.user_table_phone}</span>
                          <span className="th">{Strings.user_table_role}</span>
                          <span className="th"></span>
                        </div>
                        {users.map(user => {
                          let inline = this.state.inlineUsers.findIndex(id => id === user.id);
                          if (inline !== -1) {
                            return <UpdateSingleUser
                              form={'UpdateSingleUser' + user.id} initialValues={user}
                              removeInlineUser={this.removeInlineUser} />
                          }
                          return (
                            <div className="tr">
                              <span className="td">{user.name}</span>
                              <span className="td">{user.email_address}</span>
                              <span className="td">{user.country_code + user.phone_number}</span>
                              <span className="td">{user.role.name}</span>
                              <span className="td">
                                <div id="confirmPopPo">
                                  <button className='delete-bnt' type='button' onClick={() => this.handleUserEditClick(user)}>
                                    <i className="material-icons">create</i>
                                  </button>
                                  {/* {user.role.org_default_role === 0 ? */}
                                  <Popconfirm
                                    title={Strings.user_list_confirm_delete_alert}
                                    // icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                    onConfirm={() => this.handdleDeleteUserClick(user)}
                                    placement="topRight"
                                    okText="Yes"
                                    cancelText="No"
                                    className="delete-bnt"
                                    getPopupContainer={() => document.getElementById('confirmPopPo')}
                                  >
                                    <button className='delete-bnt' userid={user.id}>
                                      <i className="fa fa-trash-o"></i>
                                    </button>
                                  </Popconfirm>
                                  {/* deleteFunc(user)} */}
                                </div>
                              </span>
                            </div>
                          )
                        })}
                      </div>
                      <form onSubmit={handleSubmit(this.handleOrgUserSubmit)}>
                        <FieldArray name="org_users" component={this.renderMembers} />
                        {
                          this.props.formValues && this.props.formValues.org_users && this.props.formValues.org_users.length > 0
                            ? <div className="s-n-bnt btn-hs-icon sm-bnt ml-4">
                              <button type="submit" className="bnt bnt-active">
                                <i className="material-icons">save</i>{Strings.save_btn}</button>
                            </div>
                            : null
                        }
                      </form>
                    </div>
                  </PerfectScrollbar>
                </div>
              </div>
            </div>
          </div>

          {/* Edit */}
          <div className="col-md-12 col-lg-4">
            <div className="sf-card mb-4" style={{ display: this.state.displayEdit }}>
              <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                <h4 className="sf-sm-hd sf-pg-heading">{Strings.edit_org_card}</h4>
                <button className="closed-btn" onClick={this.handleCancel}><Icon type="close" /></button>
              </div>
              <div className="sf-card-body">
                <form onSubmit={handleSubmit(this.onSubmit)}>
                <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.org_name}
                      name="name"
                      type="text"
                      id=""
                      component={customInput} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.org_pri_person}
                      name="primary_person"
                      type="text"
                      id="primary_person"
                      component={customInput} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.org_phone}
                      name="phone_number"
                      type="text"
                      id=""
                      component={customInput} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.org_email}
                      name="email_address"
                      type="text"
                      id=""
                      component={customInput} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.website_txt}
                      name="website"
                      type="text"
                      id=""
                      component={customInput} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.notification_email_txt}
                      name="notification_email"
                      type="text"
                      id=""
                      component={customInput} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.org_address}
                      name="address"
                      type="text"
                      id="address"
                      component={customTextarea} />
                  </fieldset>

                  <fieldset className="form-group sf-form">
                    <Field
                      label={Strings.org_abn}
                      name="abn_acn"
                      type="text"
                      id=""
                      component={customInput} />
                  </fieldset>

                  <div className="form-group">
                    <div className="add-new-file">
                      <div className="view-logo">
                        {this.state.logoImageURL !== null ? <img alt="" src={this.state.logoImageURL} /> : organization ? organization.logo ? <img alt="" src={organization.logo} /> : <b>{abbrivationStr(organization.name)}</b> : null}
                        {/* {organization ? organization.logo ? <img src={organization.logo} /> : <b>{abbrivationStr(organization.name)}</b> : null} */}
                      </div>
                      <div className="edit-img-title">
                        <Upload {...uploadPicProps} >
                          <span className="edit-image-logo">{Strings.org_edit_img}</span>
                        </Upload>
                      </div>
                    </div>
                  </div>

                  <div className="all-btn multibnt">
                    <div className="btn-hs-icon d-flex justify-content-between">
                      <button onClick={this.handleCancel} className="bnt bnt-normal" type="button" disabled={!this.props.isDirty}>
                        {Strings.cancel_btn}</button>
                      <button type="submit" className="bnt bnt-active" disabled={!this.props.isDirty}>
                        {Strings.update_btn}</button>
                    </div>
                  </div>

                </form>
              </div>


            </div>
            <div className="sf-card mb-4" style={{ display: this.state.industryFlag }}>
              <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                <h4 className="sf-sm-hd sf-pg-heading">{Strings.edit_indstry_details}</h4>
                <button className="closed-btn" onClick={this.handleCancel}><Icon type="close" /></button>
              </div>
              <div className="sf-card-body mt-2 edit-updet-sai">
                <EditSingleService serviceObject={this.state.selectedService} initValueFromEdit={true}
                  industryId={this.state.selectedIndustryId} service_agent_id={organization ? organization.id : null}
                  handleCancel={this.handleCancel} getSubCategories={this.props.subcategoryAction.getSubCategories} />
              </div>
            </div>
            {/** Update Billing Address Info */}
            <EditBillingAddress
              handleCancel={this.handleCancel}
              addressInfoFlag={this.state.addressInfoFlag}
              organization={organization}
            />

            {/* update payment option */}
            <AddEditBillingDetails
              billingFlag={this.state.billingFlag}
              handleCancel={this.handleCancel}
              organization={organization}
            />

            {/* update Subscription Level */}
            <EditSubscriptionLevel
              showSubscriptionLevel={this.state.showSubscriptionLevel}
              handleCancel={this.handleCancel}
              organization={organization}
            />

            {/* *Subscription Details
            <div className="sf-card">
              <Collapse className="sf-collps-rt" defaultActiveKey={['1']} onChange={this.EditSubscriptionLevelHandler}
                expandIcon={({ isActive }) => <Icon type="caret-up" rotate={isActive ? 180 : 0} />}>
                <Panel header={Strings.sub_card} key="1">
                  <div className="sf-card-body">
                    <div className="view-text-value mb-3">
                      <label>{Strings.sub_type}</label>
                      <span>{organization ?
                        this.props.subscriptions.find(sub => sub.subscription_id === organization.subscription_id) ?
                          this.props.subscriptions.find(sub => sub.subscription_id === organization.subscription_id).name : ''
                        : ''}</span>
                    </div>

                    <div className="view-text-value mb-3">
                      <label>{Strings.sub_invoice_date}</label>
                      <span>{organization && organization.invoice_start_date
                        ? organization.invoice_start_date.split('T')[0] : ''}</span>
                    </div>
                    <div className="view-text-value mb-3">
                      <label>{Strings.sub_percentage}</label>
                      <span>{organization ? organization.sub_discount : ''}</span>
                    </div>
                    <div className="view-text-value mb-3">
                      <label>{Strings.sub_discount_period}</label>
                      <span>{organization ? organization.sub_period : ''}</span>
                    </div>
                    <div className="view-text-value mb-3">
                      <label>{Strings.sub_discount_amt}</label>
                      <span>${organization ? organization.sub_amount : 0}</span>
                    </div>
                    <div className="view-text-value mb-2">
                      <label>{Strings.sub_date}</label>
                      <span>{organization ? organization.subscription_start_date : ''}</span>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div> */}

            {/**Subscription Details */}
            {this.state.showSubscriptionLevel === 'none' ?
              <div className="sf-card">
                <div className="sf-card-head abb-1 d-flex justify-content-between align-items-center">
                  <h4 className="sf-sm-hd sf-pg-heading">{Strings.sub_card}</h4>
                  <div className="info-btn ">
                    <Dropdown className="more-info" overlay={this.editSubscriptionLevelMenu}>
                      <i className="material-icons">more_vert</i>
                    </Dropdown>
                  </div>
                </div>
                <div className="sf-card-body">
                  <div className="view-text-value mb-3 sub-status-dtl">

                    {organization && organization.subscription && organization.subscription.active ? <span className="sub-pill active">Active</span> : <span className="sub-pill inactive">Inactive</span>}
                    <label>{Strings.sub_type}</label>
                    <span>{organization && organization.subscription ? organization.subscription.name : ''}</span>


                    {organization && organization.subscription && organization.subscription.amount ? <div className="sub-amt-period">
                      <span>{currencyFormat(organization.subscription.amount)}</span>
                      <span>{organization && organization.subscription && organization.subscription.period ?
                        organization.subscription.period === 1 ? "Month" :
                          organization.subscription.period === 3 ? "Quarter" :
                            organization.subscription.period === 12 ? "Year" : null : null}</span>
                    </div> : null}
                  </div>

                  <div className="view-text-value mb-3">
                    <label>{Strings.sub_invoice_date}</label>
                    <span>{organization && organization.invoice_start_date
                      ? organization.invoice_start_date.split('T')[0] : ''}</span>
                  </div>
                  {organization && organization.sub_discount ? <div className="view-text-value mb-3">
                    <label>{Strings.sub_percentage}</label>
                    <span>{organization ? organization.sub_discount : ''}</span>
                  </div> : null}
                  {organization && organization.sub_period ? <div className="view-text-value mb-3">
                    <label>{Strings.sub_discount_period}</label>
                    <span>{organization ? organization.sub_period : ''}</span>
                  </div> : null}
                  <div className="view-text-value mb-3">
                    <label>{Strings.sub_discount_amt}</label>
                    <span>{organization && currencyFormat(organization.sub_amount)}</span>
                  </div>
                  <div className="view-text-value mb-2">
                    <label>{Strings.sub_date}</label>
                    <span>{organization ? organization.subscription_start_date : ''}</span>
                  </div>
                </div>
              </div> : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToprops = dispatch => {
  return {
    action: bindActionCreators(actions, dispatch),
    subscriptionAction: bindActionCreators(subscriptionAction, dispatch),
    rolesActions: bindActionCreators(rolesActions, dispatch),
    orgUserActions: bindActionCreators(orgUserActions, dispatch),
    subcategoryAction: bindActionCreators(subcategoryAction, dispatch),
  }
}


const mapStateToProps = (state, ownProps) => {
  let value = state.organization.organizations.find(organ => organ.id === ownProps.location.state);
  return {
    organizations: state.organization.organizations,
    initialValues: { ...value, org_industries: [] },
    users: state.organizationUsers.users,
    roles: state.roleManagement.roles,
    billingDetails: state.organizationBilling.billingDetails,
    subscriptions: state.subscription.subscriptions,
    formValues: state.form.viewEditOrganization && state.form.viewEditOrganization.values,
    isDirty: isDirty('viewEditOrganization')(state),
    industries: state.industryManagement.industries,
    services: state.serviceManagement.services,
    categories: state.categoryManagement.categories,
    subCategories: state.subCategoryManagement.subCategories,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToprops),
  reduxForm({
    form: 'viewEditOrganization', validate, enableReinitialize: true, onSubmitFail: (errors, dispatch, sub, props) => {
      handleFocus(errors, "#");
    }
  })
)(ViewEditOrganization)
